export const PROD_SITE = 1;

export const MEINV_TUPIAN = ['lltq', 'jpmv'];